<template>
    <div>
        <h4 style="margin-top:0;">Signature électronique</h4>

        <tabs>
            <tab title="En cours">
                <non-void-contract
                    :contract-id="contractId"
                    :customer-id="customerId"
                    :show-action-buttons="showActionButtons"
                ></non-void-contract>
            </tab>

            <tab title="Annulés">
                <void-contracts 
                    :contract-id="contractId"
                ></void-contracts>
            </tab>

            <!-- <tab title="Signataires">
                <signatories
                    :customer-id="customerId"
                ></signatories>
            </tab> -->
        </tabs>
    </div>
</template>

<script>
    import Tabs from 'components/SimpleTabs/Tabs'
    import Tab from 'components/SimpleTabs/Tab'
    import NonVoidContract from './DigitalSignature/NonVoidContract'
    import VoidContracts from './DigitalSignature/VoidContracts'
    // import Signatories from './DigitalSignature/Signatories'

    export default {
        data() {
            return {}
        },

        props: {
            contractId: {
                type: Number,
                required: true
            },
            customerId: {
                type: Number,
                required: true
            },
            parentComponent: {
                type: String,
                required: true
            }
        },

        components: {
            Tabs,
            Tab,
            NonVoidContract,
            VoidContracts
            // Signatories
        },

        computed: {
            showActionButtons() {
                return 'validationRequestForm' == this.parentComponent
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts/DigitalSignature.vue